import type { DynamicClient } from '@dynamic-labs-sdk/client';
import {
  WalletProviderPriority,
  getWalletProviderRegistry,
  waitForProjectSettings,
} from '@dynamic-labs-sdk/client/core';
import { getSignClient } from '@dynamic-labs-sdk/wallet-connect/core';

import { createWalletProviderFromEIP155Session } from '../createWalletProviderFromEIP155Session';

/** @not-instrumented */
export const recoverEvmWalletConnectWalletProviders = async (
  client: DynamicClient
) => {
  await waitForProjectSettings(client);

  const signClient = await getSignClient(client);

  /**
   * Recreate the wallet providers for all existing EVM sessions
   */
  const sessions = signClient.session.getAll();

  const currentTime = Math.floor(Date.now() / 1000);

  for (const session of sessions) {
    if (!('eip155' in session.namespaces)) {
      continue;
    }

    if (session.expiry <= currentTime) {
      continue;
    }

    const walletProvider = await createWalletProviderFromEIP155Session(
      {
        sessionTopic: session.topic,
      },
      client
    );

    getWalletProviderRegistry(client).register({
      priority: WalletProviderPriority.WALLET_SDK,
      walletProvider,
    });
  }
};
